// extracted by mini-css-extract-plugin
module.exports = {"container":"DatabaseLayout_container__TdBwR"};